import axios from 'axios';
const URL_PATH = '/newsletter/global-markets';
const httpClient = axios.create({
	headers: {
		'X-Correlation-ID': window.crypto.randomUUID()
	}
});
httpClient.interceptors.request.use((config) => {
	config.headers = {
		...config.headers,
		'X-Request-ID': window.crypto.randomUUID()
	};
	return config;
});
export const subscribe = (apiUrl, params) => {
	return httpClient.post(`${apiUrl}${URL_PATH}/subscriptions`, params);
};
export const modifyRequest = (apiUrl, params) => {
	return httpClient.put(`${apiUrl}${URL_PATH}/subscriptions/modify-request`, params);
};
export const modify = (apiUrl, params) => {
	return httpClient.put(`${apiUrl}${URL_PATH}/subscriptions`, params);
};
export const finalize = (apiUrl, params) => {
	return httpClient.get(`${apiUrl}${URL_PATH}/subscriptions/finalize/${params.token}`);
};
export const unsubscribeRequest = (apiUrl, params) => {
	return httpClient.put(`${apiUrl}${URL_PATH}/subscriptions/unsubscribe-request`, params);
};
export const deleteSubscription = (apiUrl, params) => {
	return httpClient.delete(`${apiUrl}${URL_PATH}/subscriptions/${params.token}`);
};
export const getAllTypes = (apiUrl) => {
	return httpClient.get(`${apiUrl}${URL_PATH}/newsletters/types`);
};
